import ROUTES, { EDDM_ROUTING } from "config/routing";
import D2DCardImage from "static/media/D2DCardImage.png";
import D2DDisabledCardImage from "static/media/door-to-door-disabled.svg";
import DMCardImage from "static/media/DMCardImage.png";
import DMDisabledCardImage from "static/media/direct-mail-disabled.svg";
import suburbanAreas from "static/media/suburban-areas.svg";
import goodConversion from "static/media/good-conversion.svg";
import H2HCardImg from "static/media/H2HCardImage.png";
import H2HDisabledCardImage from "static/media/hand-to-hand.svg";
import cityCenters from "static/media/city-centers.svg";
import highConversion from "static/media/high-conversion.svg";
import { CAMPAIGN_ENUM_TYPES, CAMPAIGN_SUBTYPES_ENUM } from "../shared/constants";
import { ADM_NAVIGATION } from "campaign-builder/domain/constants";

export const COUPON_CODE_ERROR_MESSAGE = {
  DEFAULT: "The coupon code you entered is invalid. Please check the code and try again. CODE: 1",
  NO_PROMO_EXIST: "The coupon code you entered is invalid. Please check the code and try again. CODE: 2",
  EXCEED_USE_PROMO: "The coupon code you entered has expired and is no longer valid. CODE: 3",
  EXCEED_USE_COUPON: "The coupon code you entered has expired and is no longer valid. CODE: 4",
  COUPON_EXPRIED: "The coupon code you entered has expired and is no longer valid. CODE: 5",
  NO_PERMISSION:
    "There was an issue with the promo code you entered. Please contact our support team for assistance. CODE: 6",
  INVALID_CURRENCY:
    "There was an issue with the promo code you entered. Please contact our support team for assistance. CODE: 7",
  MINIMUM_ORDER:
    "There was an issue with the promo code you entered. Please contact our support team for assistance. CODE: 8",
  INVALID_CURRENCY_IN_RESTRICTION:
    "There was an issue with the promo code you entered. Please contact our support team for assistance. CODE: 9",
  ONLY_FIRST: "The coupon code you entered has expired and is no longer valid. CODE: 10",
  PROMO_EXPIRED: "The coupon code you entered has expired and is no longer valid. CODE: 11",
  INCORRECT_DISCOUNT_VALUE:
    "There was an issue with the promo code you entered. Please contact our support team for assistance. CODE: 12",
  LESS_THAN:
    "There was an issue with the promo code you entered. Please contact our support team for assistance. CODE: 13",
};

export const CAMPAIGN_INTERNAL_STATUSES = {
  DRAFT: "DRAFT",
  IN_REVIEW: "IN_REVIEW",
  UPLOAD_CODES: "UPLOAD_CODES",
  CODE_REVIEW: "CODE_REVIEW",
  GENERATING_DIGITAL_PROOF: "GENERATING_DIGITAL_PROOF",
  PENDING_DIGITAL_PROOF: "PENDING_DIGITAL_PROOF",
  PRINTING: "PRINTING",
  PAYMENT: "PAYMENT",
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
};

export const READABLE_CAMPAIGN_INTERNAL_STATUSES = {
  DRAFT: "Draft",
  IN_REVIEW: "In Review",
  UPLOAD_CODES: "Upload Codes",
  CODE_REVIEW: "Code Review",
  GENERATING_DIGITAL_PROOF: "Generating Digital Proof",
  PENDING_DIGITAL_PROOF: "Pending Digital Proof",
  PRINTING: "Printing",
  PAYMENT: "Printing",
  ACTIVE: "Active",
  COMPLETED: "Completed",
  REJECTED: "Rejected",
};

export const MAP_TYPES = {
  CIRCLE: "circle",
  POLYGON: "polygon",
  MARKER: "marker",
  DRAG: "drag",
};

export const HAND2HAND_TYPES = {
  BROAD_AREAS: "BROAD_AREAS",
  PRECISE_LOCATIONS: "PRECISE_LOCATIONS",
};

export const COLORS = {
  BLUE: "#4A86E8",
  RED: "#EE4360",
  ORANGE: "#FF5C00",
  YELLOW: "#FFB03A",
  GREEN: "#32935A",
  WHITE: "#FFFFFF",
  GRAY: "#73797E",
};

export const HEADER_TITLE = {
  CAMPAIGN_CHANNEL: "Channel",
  CAMPAIGN_DETAILS: "Details",
  CAMPAIGN_AUDIENCE: "Audience",
  CAMPAIGN_SEGMENTS: "Segments",
  // EDDM topbar step labels aligned with the redesigned channels (StepHeader):
  // Targeting / Design / Tracking. These are display-only — step identity is
  // keyed off the `step` field, not the title.
  TARGETING: "Targeting",
  TRACKING: "Tracking",
  FLYER_BUILDER: "Design",
  UPLOAD_DESIGN: "Upload design",
  FLYER_CANVAS: "Flyer canvas",
  SUBMIT: "Submit",
};

export const CAMPAIGN_CHANNELS_MIN_RECIPIENTS = {
  [CAMPAIGN_SUBTYPES_ENUM.ADM]: 1000,
  [CAMPAIGN_SUBTYPES_ENUM.EDDM]: 1000,
};

export const NAVIGATION = [
  // {
  //   title: HEADER_TITLE.CAMPAIGN_CHANNEL,
  //   href: ROUTES.CAMPAIGN_CHANNEL,
  //   step: "channel",
  //   index: 0,
  // },
  {
    title: HEADER_TITLE.CAMPAIGN_AUDIENCE,
    href: ROUTES.CAMPAIGN_AUDIENCE,
    step: "audience",
    index: 1,
  },
  {
    title: HEADER_TITLE.FLYER_BUILDER,
    href: ROUTES.FLYER,
    step: "design",
    index: 2,
  },
  {
    title: HEADER_TITLE.CAMPAIGN_DETAILS,
    href: ROUTES.CAMPAIGN_DETAILS,
    step: "details",
    index: 3,
  },
  {
    title: HEADER_TITLE.SUBMIT,
    href: ROUTES.SUBMIT,
    step: "submit",
    index: 4,
  },
];

export const EDDM_NAVIGATION = [
  {
    title: HEADER_TITLE.TARGETING,
    href: EDDM_ROUTING.EDDM_CAMPAIGN_SEGMENTS,
    step: "segments",
    index: 1,
  },
  {
    title: HEADER_TITLE.FLYER_BUILDER,
    href: EDDM_ROUTING.EDDM_FLYER,
    step: "design",
    index: 2,
  },
  {
    title: HEADER_TITLE.TRACKING,
    href: EDDM_ROUTING.EDDM_SUBMIT,
    step: "submit",
    index: 3,
  },
];

export const CHANNEL_NAVIGATION = {
  [CAMPAIGN_SUBTYPES_ENUM.EDDM]: EDDM_NAVIGATION,
  [CAMPAIGN_SUBTYPES_ENUM.ADM]: ADM_NAVIGATION,
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: NAVIGATION,
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: NAVIGATION,
};

export const CHANNEL_OPTIONS = {
  [CAMPAIGN_ENUM_TYPES.HANDTOHAND]: {
    img: H2HCardImg,
    disabledImg: H2HDisabledCardImage,
    type: CAMPAIGN_ENUM_TYPES.HANDTOHAND,
    title: "Hand to hand",
    subTitle:
      "Our Brand Ambassadors distribute your flyers and leaflets in the streets and catch your target audience on their way: in the streets, around universities, stations, parks, and much more.",
    benefits: [
      { icon: cityCenters, text: "City centers" },
      { icon: highConversion, text: "High conversion" },
    ],
  },
  [CAMPAIGN_ENUM_TYPES.LETTERBOX]: {
    img: D2DCardImage,
    disabledImg: D2DDisabledCardImage,
    type: CAMPAIGN_ENUM_TYPES.LETTERBOX,
    title: "Door to door",
    subTitle: "Reach your future customers directly at home with our seamless letterbox drop flyer distribution.",
    benefits: [
      { icon: suburbanAreas, text: "Suburban areas" },
      { icon: goodConversion, text: "Good conversion" },
    ],
  },
  [CAMPAIGN_ENUM_TYPES.DIRECTMAIL]: {
    img: DMCardImage,
    disabledImg: DMDisabledCardImage,
    type: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
    title: "Local direct mail",
    subTitle:
      "Deliver your message directly in your target audience's mailbox. Decide where and when you want your flyers distributed and let us take care of the rest.",
    benefits: [
      { icon: suburbanAreas, text: "Suburban areas" },
      { icon: goodConversion, text: "Good conversion" },
    ],
  },
};

export const PAPER_WEIGHT = [
  { title: "200G", value: "200" },
  { title: "300G", value: "300" },
  { title: "350G", value: "350" },
];

export const FLYER_TYPES = [
  { value: "TEARAWAY", name: "TEARAWAY" },
  { value: "a6", name: "A6" },
];

export const FLYER_WEIGHTS = [
  { value: "300", name: "300" },
  { value: "400", name: "400" },
  { value: "500", name: "500" },
];

export const platformUSACities = {
  Athens: "GA",
  Atlanta: "GA",
  Austin: "TX",
  Boston: "MA",
  Charleston: "SC",
  Charlotte: "NC",
  Chicago: "IL",
  Dallas: "TX",
  Denver: "CO",
  "Fort Myers": "FL",
  Jacksonville: "FL",
  Houston: "TX",
  "Jersey City": "NJ",
  "Los Angeles": "CA",
  Miami: "FL",
  "New York City": "NY",
  Philadelphia: "PA",
  Phoenix: "AZ",
  "San Antonio": "TX",
  "San Diego": "CA",
  Sarasota: "FL",
  Savannah: "GA",
  "San Francisco": "CA",
  Seattle: "WA",
  Tampa: "FL",
  Tucson: "AZ",
};
